import type { Column, TabProps } from '@talos/kyoko';
import { pick } from 'lodash-es';
import {
  entityDisplayNames,
  type entityByRequestName,
  type MonitoringBlotterTableFilter,
} from '../../Monitoring/Blotters/types';

export interface DealerMonitoringBlotterTabProps extends TabProps {
  tag?: string;
  name?: CustomerEntityName;
  defaultFilter?: MonitoringBlotterTableFilter;
  defaultColumns?: Column[];
}

export const customerEntityDisplayNames = pick(entityDisplayNames, [
  'CustomerOrder',
  'CustomerQuote',
  'CustomerExecutionReport',
  'CustomerTrade',
] as const);

export type CustomerEntityName = keyof typeof customerEntityDisplayNames;

export type DealerBlotterTableEntity = (typeof entityByRequestName)[CustomerEntityName];
